import React, { useEffect, useState, useRef } from "react";
import styles from "./ShopPage.module.scss";
import InjectorCard from "@/components/InjectorCard/InjectorCard";
import Nav from "@/components/Header/Nav/Nav";
import Footer from "@/components/Footer/Footer";
import CategoryList from "@/components/Shop/CategoryList";
import { useNavigate, useSearchParams } from "react-router-dom";
import CategoryMenu from "@/components/CategoryMenu/CategoryMenu.tsx"; // Імпортуємо спливаюче меню категорій
import type { KeyboardEvent, ChangeEvent } from "react";
import { Helmet } from "react-helmet";

const ShopPage: React.FC = () => {
  const [products, setProducts] = useState<any[]>([]);
  const [totalProducts, setTotalProducts] = useState<number>(0);
  const [selectedCategory, setSelectedCategory] = useState<string | null>(null);
  const [loading, setLoading] = useState(false);
  const [hasMore, setHasMore] = useState(true);
  const [page, setPage] = useState(1);
  const [searchParams] = useSearchParams();
  const searchQuery = searchParams.get("search")?.trim() || "";
  const [isMenuOpen, setIsMenuOpen] = useState(false); // Стан для відкриття меню категорій
  const [sortOrder, setSortOrder] = useState<string>("default"); // Стан для сортування
  const initialQuery = searchParams.get("search") || "";
  const [query, setQuery] = useState(initialQuery);
  const navigate = useNavigate();
  const observer = useRef<IntersectionObserver | null>(null);
  const bottomRef = useRef<HTMLDivElement | null>(null);
  const [screenWidth, setScreenWidth] = useState<number>(window.innerWidth); // Стан для ширини екрану

  useEffect(() => {
    // Функція для оновлення ширини екрану при зміні розміру вікна
    const handleResize = () => {
      setScreenWidth(window.innerWidth);
    };

    window.addEventListener("resize", handleResize); // Додаємо слухача для зміни розміру вікна

    return () => {
      window.removeEventListener("resize", handleResize); // Очищаємо слухач при розмонтуванні компонента
    };
  }, []);

  useEffect(() => {
    window.scrollTo(0, 0); // Скролимо в верх сторінки
  }, []);

  // // Функція для отримання назви категорії за id
  // const getCategoryName = async (categoryId: string) => {
  //   try {
  //     const response = await fetch(`https://crm.hixa.eu/external/goodsapi/`, {
  //       method: "POST",
  //       headers: {
  //         Authorization: `Bearer DH345DFGDGb32FDsf03876SDFSdf13`,
  //         "Content-Type": "application/x-www-form-urlencoded",
  //         Accept: "application/json",
  //       },
  //       body: new URLSearchParams({
  //         type: "category",
  //         legid: "1",
  //       }),
  //     });
  //     const data = await response.json();
  //     return data.success ? data.data[categoryId] : "Category not found";
  //   } catch (error) {
  //     console.error("Error fetching category name:", error);
  //     return "Category not found";
  //   }
  // };

  // // Функція для отримання назви підкатегорії за id
  // const getSubcategoryName = async (
  //   categoryId: string,
  //   subcategoryId: string
  // ) => {
  //   try {
  //     const response = await fetch(`https://crm.hixa.eu/external/goodsapi/`, {
  //       method: "POST",
  //       headers: {
  //         Authorization: `Bearer DH345DFGDGb32FDsf03876SDFSdf13`,
  //         "Content-Type": "application/x-www-form-urlencoded",
  //         Accept: "application/json",
  //       },
  //       body: new URLSearchParams({
  //         type: "category",
  //         legid: "1",
  //         catid: categoryId,
  //       }),
  //     });
  //     const data = await response.json();
  //     console.log("Категорія", categoryId);
  //     console.log(data);
  //     return data.success ? data.data[subcategoryId] : "Category not found";
  //   } catch (error) {
  //     console.error("Error fetching category name:", error);
  //     return "Category not found";
  //   }
  // };

  // const [categoryName, setCategoryName] = useState<string | null>(null);
  // const [subcategoryName, setSubcategoryName] = useState<string | null>(null);

  // useEffect(() => {
  //   // Якщо є категорія, отримуємо її назву
  //   if (categoryId) {
  //     getCategoryName(categoryId).then((name) => setCategoryName(name));
  //   }

  //   // Якщо є підкатегорія, отримуємо її назву
  //   if (subcategoryId && categoryId) {
  //     getSubcategoryName(categoryId, subcategoryId).then((name) =>
  //       setSubcategoryName(name)
  //     );
  //   }
  // }, [categoryId, subcategoryId]);

  // Завантаження товарів
  const fetchProducts = async () => {
    if (loading) return;
    setLoading(true);

    const categoryId = selectedCategory || "0";

    const res = await fetch("https://crm.hixa.eu/external/goodsapi/", {
      method: "POST",
      headers: {
        Authorization: `Bearer DH345DFGDGb32FDsf03876SDFSdf13`,
        "Content-Type": "application/x-www-form-urlencoded",
        Accept: "application/json",
      },
      body: new URLSearchParams({
        type: "good",
        onlyprice: "1",
        start: ((page - 1) * 10).toString(),
        limit: "10",
        legid: "1",
        catid: categoryId,
        ...(searchQuery && { search: searchQuery }), // ← додаємо параметр пошуку
      }),
    });

    const data = await res.json();

    if (data.success && data.data) {
      setProducts((prev) => {
        const newProducts = data.data.filter(
          (newProduct: any) =>
            !prev.some(
              (existingProduct) => existingProduct.goid === newProduct.goid
            )
        );
        return [...prev, ...newProducts];
      });
      setTotalProducts(data.total);
      setHasMore(data.data.length > 0 && products.length < data.total);
    }

    setLoading(false);
  };

  // 🔁 Категорія
  useEffect(() => {
    setProducts([]);
    setPage(1);
    fetchProducts();
  }, [selectedCategory]);

  // 🔁 Пошук
  useEffect(() => {
    setProducts([]);
    setPage(1);
  }, [selectedCategory, searchQuery]);

  useEffect(() => {
    fetchProducts();
  }, [page, selectedCategory, searchQuery]);

  // Використовуємо IntersectionObserver для підвантаження товарів при прокручуванні
  useEffect(() => {
    const loadMoreProducts = () => {
      if (!loading && hasMore) {
        setPage((prevPage) => prevPage + 1);
        fetchProducts();
      }
    };

    if (observer.current) observer.current.disconnect(); // Очищаємо попередній спостерігач

    const options = {
      root: null,
      rootMargin: "0px 0px -250px 0px", // Збільшено, щоб підвантаження починалось пізніше
      threshold: 1.0,
    };

    observer.current = new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          loadMoreProducts();
        }
      });
    }, options);

    const target = bottomRef.current;
    if (target) observer.current.observe(target);

    return () => {
      if (observer.current) observer.current.disconnect();
    };
  }, [loading, hasMore, page]);

  // Функція для сортування на клієнтській стороні
  const sortProducts = (products: any[], order: string) => {
    if (order === "_price_ASC") {
      return products.sort((a, b) => a.purchaseprice - b.purchaseprice);
    }
    if (order === "_price_DESC") {
      return products.sort((a, b) => b.purchaseprice - a.purchaseprice);
    }
    return products;
  };

  const handleSortChange = (event: React.ChangeEvent<HTMLSelectElement>) => {
    const newOrder = event.target.value;
    setSortOrder(newOrder);
    const sortedProducts = sortProducts([...products], newOrder); // Сортуємо продукти після вибору
    setProducts(sortedProducts);
  };

  const handleKeyDown = (e: KeyboardEvent<HTMLInputElement>) => {
    if (e.key === "Enter") handleSearch();
  };

  const handleChange = (e: ChangeEvent<HTMLInputElement>) => {
    setQuery(e.target.value);
  };

  const handleSearch = () => {
    const trimmed = query.trim();
    if (trimmed) {
      navigate(`/shop?search=${encodeURIComponent(trimmed)}`);
    }
  };

  const schemaOrgData = {
    "@context": "https://schema.org",
    "@type": "Store",
    name: "Hixa",
    address: {
      "@type": "PostalAddress",
      streetAddress: "Neukirchstraße 74",
      addressLocality: "Berlin",
      postalCode: "13089",
      addressCountry: "DE",
    },
    openingHours: [
      "Mo 08:00-12:00, 13:00-17:00",
      "Tu 08:00-12:00, 13:00-17:00",
      "We 08:00-12:00, 13:00-17:00",
      "Th 08:00-12:00, 13:00-17:00",
      "Fr 08:00-12:00, 13:00-17:00",
      "Sa 09:00-13:00",
      "Su Closed",
    ],
    telephone: "+493052015191",
    url: "https://hixa.eu/shop/",
  };

  return (
    <div className="pageSection">
      <title>Shop – HIXA – DSG Getriebe Reparatur & Wartung</title>
      <link rel="icon" href="/images/favicon.ico" type="image/x-icon" />

      <Helmet>
        <script type="application/ld+json">
          {JSON.stringify(schemaOrgData)}
        </script>
      </Helmet>
      <Nav />

      <div className="container">
        <div className={styles.shopContainer}>
          {searchQuery && (
            <div className={styles.searchTitle}>
              Suchergebnisse für: <strong>{searchQuery}</strong>
            </div>
          )}
          <div className="sideP88 titleCont">
            <div className={`titleBlock ${styles.shopTitleBlock}`}>
              <span className={styles.navigation}>
                <a href="/">Home</a>

                <span className={styles.separator}>/</span>
                <a href="/shop">Shop</a>

                {/* <>
                  <span className={styles.separator}>/</span>
                  <p>{selectedCategory}</p>
                </> */}

                {/* {subcategoryId && (
                  <>
                    <span className={styles.separator}>/</span>
                    <p>{subcategoryName || "Loading subcategory..."}</p>
                  </>
                )} */}
              </span>
              {/* <h1>Shop</h1> */}
            </div>
          </div>
          <div className={`${styles.mainContent} sideP88`}>
            {screenWidth > 1025 && (
              <div className={styles.mainCategoryBlock}>
                <CategoryList
                  selectedCategory={selectedCategory}
                  onSelectCategory={(id) => {
                    setSelectedCategory(id);
                  }}
                />
              </div>
            )}

            <div className={styles.mainProductBlock}>
              <div className={styles.controlsPanel}>
                {screenWidth <= 1025 && (
                  <>
                    <div className={` textBasic ${styles.filterTitle}`}>
                      Filter
                    </div>
                    <div className={styles.searchBar}>
                      <input
                        type="text"
                        value={query}
                        onChange={handleChange}
                        onKeyDown={handleKeyDown}
                        placeholder="Suche Produkt..."
                      />
                      <button
                        className={styles.button}
                        aria-label="Suche starten"
                        onClick={handleSearch}
                      >
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          viewBox="0 0 512 512"
                        >
                          <path d="M495,466.2L377.2,348.4c29.2-35.6,46.8-81.2,46.8-130.9C424,103.5,331.5,11,217.5,11C103.4,11,11,103.5,11,217.5S103.4,424,217.5,424c49.7,0,95.2-17.5,130.8-46.7L466.1,495c8,8,20.9,8,28.9,0C503,487.1,503,474.1,495,466.2z M217.5,382.9C126.2,382.9,52,308.7,52,217.5S126.2,52,217.5,52C308.7,52,383,126.3,383,217.5S308.7,382.9,217.5,382.9z" />
                        </svg>
                      </button>
                    </div>
                    <button
                      onClick={() => setIsMenuOpen(true)}
                      className={styles.categoryButton}
                    >
                      Filter
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        viewBox="0 0 512 512" // Потрібно точно співвідносити з фактичними розмірами
                        width="26.5" // Розмір по ширині
                        height="32" // Розмір по висоті
                        style={{
                          fill: "black",
                          width: "100%",
                          height: "100%",
                          display: "block",
                        }} // Для максимального заповнення
                      >
                        <path d="M64 144h226.75a48 48 0 0090.5 0H448a16 16 0 000-32h-66.75a48 48 0 00-90.5 0H64a16 16 0 000 32zM448 368h-66.75a48 48 0 00-90.5 0H64a16 16 0 000 32h226.75a48 48 0 0090.5 0H448a16 16 0 000-32zM448 240H221.25a48 48 0 00-90.5 0H64a16 16 0 000 32h66.75a48 48 0 0090.5 0H448a16 16 0 000-32z" />
                      </svg>
                    </button>
                  </>
                )}
              </div>

              <select
                id="sort-filter"
                className={styles.filterSelect}
                data-brx-filter="true"
                name="form-field-lcyvbw"
                value={sortOrder}
                onChange={handleSortChange}
              >
                <option value="default">Select sort</option>
                <option value="_price_ASC">Price: Low - High</option>
                <option value="_price_DESC">Price: High - Low</option>
              </select>

              <div className={styles.productList}>
                {products.map((product) => {
                  if (!product.goid) console.warn("Missing goid in:", product);
                  const imageUrl = product.files?.image
                    ? (Object.values(product.files.image)[0] as string)
                    : undefined;
                  return (
                    <InjectorCard
                      key={product.goid}
                      goid={product.goid}
                      name={product.name}
                      price={product.price}
                      imageUrl={imageUrl}
                    />
                  );
                })}
              </div>

              {/* Виведення кількості товарів */}
              <div className={styles.productCount}>
                Anzeigen 1 - {Math.min(products.length, totalProducts)} von{" "}
                {totalProducts} gesamt
              </div>

              {/* Підвантаження товарів при досягненні кінця сторінки */}
              <div ref={bottomRef} style={{ height: "50px" }}></div>
            </div>
          </div>
        </div>
      </div>

      <CategoryMenu
        selectedCategory={selectedCategory}
        onSelectCategory={setSelectedCategory}
        isOpen={isMenuOpen}
        onClose={() => setIsMenuOpen(false)} // Функція для закриття меню
      />

      <Footer></Footer>
    </div>
  );
};

export default ShopPage;
